import { makeStyles } from '@material-ui/core/styles';
import { Button } from 'components/common/Button/Button';
import styles from '../containers/Events.scss';

const useStyles = makeStyles({
    secondaryConfirmationBtn: {
        textTransform: 'capitalize',
        borderRadius: '3px',
        border: '2px solid var(--grey-600, #B1B1B1)',
        color: '#28282E',
        fontSize: '16px',
        fontWeight: 600,
        width: '100%',
        maxHeight: '41px',
    },
});

function DeleteEventDialog({ onDelete, onCancel}) {
    const classes = useStyles();
    return (
        <div className={styles.removeStudyUser}>
            Are you sure you want to delete this Event?
            <div className={styles.removeStudyUserConfirmBtn}>
                <Button
                    variant="outlined"
                    className={classes.secondaryConfirmationBtn}
                    onClick={onDelete}
                >
                    Yes
                </Button>
                <Button
                    variant="outlined"
                    className={classes.secondaryConfirmationBtn}
                    onClick={onCancel}
                >
                    No
                </Button>
            </div>
        </div>
    );
}

export default DeleteEventDialog;